import React from "react";
import Loading from "../loading/Loading";

const ReferredFormCategory = ({
  categories,
  isLoading,
  onChange,
  translate,
  referred,
  showLabel = false,
}) => {
  const handleOnChangeCategory = (e, name) => {
    let selectedKey = e.target.value;

    onChange(selectedKey, referred?._id, name);
  };

  return (
    <div>
      {showLabel && (
        <label className="label">{translate("select-category")}</label>
      )}
      {isLoading ? (
        <Loading key={"loading-categories"} />
      ) : (
        <>
          <select
            name="category"
            value={referred.stateId}
            onChange={(e) => handleOnChangeCategory(e, "stateId")}
            className="input"
          >
            {categories.map((opt, index) => (
              <option key={opt?._id + referred?._id + index} value={opt._id}>
                {translate(opt.name)}
              </option>
            ))}
          </select>

          {referred?.stateId && referred?.stateId !== "0" && (
            <>
              <input
                type="text"
                className="input mt-2"
                value={referred?.stateReason || ""}
                placeholder={translate("reason-for-selection")}
                onChange={(e) => handleOnChangeCategory(e, "stateReason")}
                maxLength={150}
              />
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                {translate("characters-remaining")}:{" "}
                {150 - (referred?.stateReason?.length || 0)}
              </p>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ReferredFormCategory;
